import React, { PropsWithChildren, useState } from "react";
import cn from "classnames";
import { HrYfmPreview, transform } from "@yandex-int/hr-components/esm/yfm/HrYfmPreview";
import { IWysiwygSettings } from "../wysiwyg-editor-yfm/wysiwyg-editor-yfm-content";
import { Icon } from "../icons/icon";
import { WysiwygEditor } from "../wysiwyg-editor-yfm/wysiwyg-editor-yfm";
import styles from "./wysiwyg-editable-preview.module.scss";


interface IWysiwygEditablePreviewProps extends PropsWithChildren {
    className?: string;
    wysiwygSettings: IWysiwygSettings;
    onEdit?: (settings: IWysiwygSettings) => void,
    onClose?: () => void;
    editable?: boolean;
}

export const WysiwygEditablePreview: React.FC<IWysiwygEditablePreviewProps> = React.memo(({
                                                                                              wysiwygSettings,
                                                                                              onEdit,
                                                                                              className,
                                                                                              onClose,
                                                                                              editable = false
                                                                                          }) => {
    const [editMode, setEditMode] = useState<boolean>(false);
    const [settings, setSettings] = useState<IWysiwygSettings>(wysiwygSettings);

    const onEditFinished = () => {
        setEditMode(false);
        onEdit && onEdit(settings);
    }

    return <div className={cn(styles.container, className)}>
        {(!!onEdit || !!onClose) && !editMode && <div className={styles.btnContainer}>
            {editable && <div className={styles.legalActionItem}>
                <Icon glyph="edit" size="l" onClick={() => setEditMode(true)}/>
            </div>}
            {!!onClose && <div className={styles.actionItem}>
                <Icon glyph="close" size="l" onClick={onClose}/>
            </div>}
        </div>}
        {editMode && <div className={styles.btnContainer}>
            <div className={styles.legalActionItem}>
                <Icon glyph="check" size="l" onClick={() => onEditFinished()}/>
            </div>
        </div>}
        {!editMode && settings.html && <HrYfmPreview html={transform({ content: settings.html, isWiki: true })}/>}
        {editMode && <WysiwygEditor
            id="wysiwyg_editable_preview"
            onChange={setSettings}
            initialValue={settings}
        />}
    </div>;
});
